import { ReactNode } from "react";
import { useIsLoggedIn } from "../context/LoginContext";
import { LoginPage } from "../pages/LoginPage";

/**
 * A component that returns its children if the user is logged in, otherwise it returns the login page
 * @param children
 * @constructor
 */
export const LoggedInOnly: React.FC<{ children?: ReactNode }> = ({
  children,
}) => {
  const isLoggedIn = useIsLoggedIn();
  return isLoggedIn ? <>{children}</> : <LoginPage />;
};
